module.exports = __webpack_public_path__ + "img/W-21.bb554c61.jpg";